// import bg from './running.png'
import './Profile.css';

function ProfileBG({ children }) {
  const silly = () => {
    document.getElementById(children.name).getElementsByClassName('aboutbg')[0].style.backgroundImage = "linear-gradient(in hsl, " + children.background.backdrop + ")";
    document.getElementById(children.name).getElementsByClassName('aboutborder')[0].style.backgroundImage = "linear-gradient(in hsl, " + children.background.border + ")";
  }

  setTimeout(silly, 0);  // the jank iS REAAAL
  return (<><div className="aboutborder" windowdrag="true"/><div className="aboutbg"/></>);
}

function Profile({ children }) {
  const styleText = children.background.text;
  return (
    <div id={children.name}>
      <style>
        {`#` + children.name + ` { color: ` + styleText.regular + `;}`
        + `#` + children.name + ` a { color: ` + styleText.link.regular + `;}`
        + `#` + children.name + ` a:hover { color: ` + styleText.link.hover + `;}`
        + `#` + children.name + ` a:visited { color: ` + styleText.link.visited + `;}`
        + `#` + children.name + ` a:hover:visited { color: ` + styleText.link.vhover + `;}`
        + `#` + children.name + ` .name { color: ` + styleText.name + `;}`
        + `#` + children.name + ` .pronouns { color: ` + styleText.pronoun + `;}`
        + `#` + children.name + ` .labels { color: ` + styleText.label + `;}`}
      </style>

      <ProfileBG>{children}</ProfileBG>

      <div className="about">
        <img src={children.background.banner.image} alt={children.background.banner.alt} id="bguwu"></img>
        <div id="silly">
          <img src={children.background.profile.image} alt={children.background.profile.alt} id="jsonProfile"></img>
        </div>

        <div id="identity">
          <span className='name'> {children.name} </span>
          <span className='pronouns'> {children.pronouns} </span>
          <br/>
          <span className='labels'>
            {children.labels.map((label, index) => {
              return <><a href={label.url} title={label.hover}>{label.name}</a>{(index == children.labels.length - 1) ? '' : ', '}</>
            })}
          </span>
        </div>

        <div id="sillytext" className='smaller'> {children.content} </div>
      </div>
    </div>
  );
}

export default Profile;